import { createContext } from 'react';
import type { NewsUmbPageContentResponseModel } from '#/_generated/umbraco/delivery-api/models';

export const NewsPagesContext = createContext<NewsUmbPageContentResponseModel[] | undefined>(undefined);
